/**
 * 配列内の項目のカウント数を足し合わせる
 *
 * @param 整数値
 *
 * @return 整数値
 */
/* eslint-disable */
const resetLocalStorageSeeker = function (id) {
  localStorage.removeItem('NM_' + id)
  localStorage.removeItem('EM_' + id)
  localStorage.removeItem('TL_' + id)
  localStorage.removeItem('AD_' + id)
  localStorage.removeItem('FR_' + id)
  localStorage.removeItem('SH_' + id)
  localStorage.removeItem('GK_' + id)
  localStorage.removeItem('BK_' + id)
  localStorage.removeItem('SC_' + id)
  localStorage.removeItem('SCR')
  localStorage.removeItem('msg')
  if (localStorage.getItem('MSG_' + id)) {
    localStorage.removeItem('MSG_' + id)
  }
}

export default resetLocalStorageSeeker



// WEBPACK FOOTER //
// ./src/functions/resetLocalStorageSeeker.js